export default __webpack_public_path__ + "294b4dd1522564b94ca95f13d1852418.svg";